import React, { useState } from "react";
import "./ReadMore.css";

const ReadMoreCustomWithStyle = ({ children, size }) => {
    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);

    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };

    return (
        <>
            {
                text != null &&
                    text.length > size ?
                    <p style={{ backgroundColor: "#52AFB52E", fontSize: "14px" }}>

                        {isReadMore ? text.slice(0, size) : text}

                        <span onClick={toggleReadMore}  className="read-or-hide">
                            {isReadMore ? "...See All" : " Show less"}
                        </span>
                    </p>
                    : <p style={{ backgroundColor: "#52AFB52E", fontSize: "14px" }}>{text}</p>
            }
        </>
    );
}

const ReadMoreContentCustomWithStyle = ({ longText, size }) => {

    return (
        <div className="text-container">
            <p>
                {
                    <ReadMoreCustomWithStyle size={size} >
                        {longText}
                    </ReadMoreCustomWithStyle>
                }
            </p>
        </div>
    );
};

export default ReadMoreContentCustomWithStyle;
